import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import styles from './UnitSymbolAsFraction.pcss';
const UnitSymbolAsFraction = ({ unitSymbol })=>{
    useStyles(styles);
    const [numerator, denominator] = unitSymbol.split('/');
    return /*#__PURE__*/ _jsxs("span", {
        className: styles.fraction,
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: styles.fraction__numerator,
                children: numerator
            }),
            /*#__PURE__*/ _jsx("span", {
                className: styles.fraction__bar
            }),
            /*#__PURE__*/ _jsx("span", {
                className: styles.fraction__denominator,
                children: denominator
            })
        ]
    });
};
export default UnitSymbolAsFraction;
